import { HealthcareProviderType } from '@dreryk/egabinet-healthcare-provider-frontend-api';

import { assertUnreachable } from '@dreryk/react-common';

import { protectFeature } from '~libs.shared.system';
import { getHealthcarePracticeP1Path } from '~legacy.p1';

import { accountConfigurationInfoTranslationKeys } from '../../translations';

import { AccountConfigurationItemProps } from './AccountConfigurationItem.types';
import { AccountConfigurationItemContent } from './AccountConfigurationItemContent';

type P1CertificatesAccountConfigurationItemContent = AccountConfigurationItemProps & {
   readonly healthcareProviderType: HealthcareProviderType;
};

const P1CertificatesAccountConfigurationItemContent = (
   props: P1CertificatesAccountConfigurationItemContent
): JSX.Element => {
   switch (props.healthcareProviderType) {
      case 'HEALTHCARE_PRACTICE':
      case 'HEALTHCARE_ORGANIZATION':
         return (
            <AccountConfigurationItemContent
               label={accountConfigurationInfoTranslationKeys.p1Certificates}
               testId='p1Certificates'
               configured={props.configured}
               url={getHealthcarePracticeP1Path(props.healthcareProviderType)}
               onRedirect={props.onRedirect}
            />
         );
      default:
         return assertUnreachable(props.healthcareProviderType);
   }
};

type P1CertificatesAccountConfigurationItemProps = AccountConfigurationItemProps & {
   healthcareProviderType: HealthcareProviderType;
};

export const P1CertificatesAccountConfigurationItem = (
   props: P1CertificatesAccountConfigurationItemProps
): JSX.Element | null => {
   return protectFeature('updatingProviderData', <P1CertificatesAccountConfigurationItemContent {...props} />, null);
};
